export default {
  'sessionExpiration.header': 'Your session will expire soon',
  'sessionExpiration.timeRemaining': 'Your session will expire in',
  'sessionExpiration.buttonInstructionsTemplate':
    'To continue your session, please click "<%= resume %>" below. You will be logged out automatically when the timer reaches <%= countEnd %>',
  'sessionExpiration.resume': 'Resume',
  'sessionExpiration.logout': 'Log Out'
};
